import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    BoothfeeService,
    BoothfeePopupService,
    BoothfeeComponent,
    BoothfeeDetailComponent,
    BoothfeeDialogComponent,
    BoothfeePopupComponent,
    BoothfeeDeletePopupComponent,
    BoothfeeDeleteDialogComponent,
    boothfeeRoute,
    boothfeePopupRoute,
    BoothfeeResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...boothfeeRoute,
    ...boothfeePopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        BoothfeeComponent,
        BoothfeeDetailComponent,
        BoothfeeDialogComponent,
        BoothfeeDeleteDialogComponent,
        BoothfeePopupComponent,
        BoothfeeDeletePopupComponent,
    ],
    entryComponents: [
        BoothfeeComponent,
        BoothfeeDialogComponent,
        BoothfeePopupComponent,
        BoothfeeDeleteDialogComponent,
        BoothfeeDeletePopupComponent,
    ],
    providers: [
        BoothfeeService,
        BoothfeePopupService,
        BoothfeeResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerBoothfeeModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee.module.ts